import Auth from '@ublend-npm/aula-auth-client';

export default Auth;
